(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function buildAmbientParticles() {
    if (reducedMotion.matches || document.querySelector('.homepage-ambient')) return;
    const ambient = document.createElement('div');
    ambient.className = 'homepage-ambient';
    ambient.setAttribute('aria-hidden', 'true');

    for (let index = 0; index < 14; index += 1) {
      const particle = document.createElement('span');
      particle.className = 'homepage-ambient__particle';
      particle.style.setProperty('--particle-left', `${6 + ((index * 23) % 90)}%`);
      particle.style.setProperty('--particle-size', `${4 + (index % 5) * 2}px`);
      particle.style.setProperty('--particle-duration', `${15 + (index % 6) * 2.5}s`);
      particle.style.setProperty('--particle-delay', `${-index * 1.7}s`);
      particle.style.setProperty('--particle-drift', `${index % 2 === 0 ? 28 + index * 2 : -24 - index * 2}px`);
      ambient.appendChild(particle);
    }
    document.body.prepend(ambient);
  }

  function prepareSections() {
    const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    if (!sections.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('home-motion-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    sections.slice(1).forEach((section) => {
      section.classList.add('home-motion-section');
      section.querySelectorAll('.testi-card, product-card, .product-card, .collection-card').forEach((item, index) => {
        item.style.setProperty('--motion-item-index', index % 6);
      });
      observer.observe(section);
    });
  }

  function initializeHomepageMotion() {
    document.body.classList.add('template-index-motion');
    buildAmbientParticles();
    prepareSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepageMotion, { once: true });
  } else {
    initializeHomepageMotion();
  }

  document.addEventListener('shopify:section:load', prepareSections);
})();
